<div class="container-fluid py-4">

  <!-- Header -->
     <div class="page-header">
    <div>
      <h2><i class="bi bi-people-fill me-2"></i>Profissionais</h2>
      <p class="text-muted mb-0">Gerencie profissionais, formas de pagamento e assinaturas</p>
    </div>
    <button class="btn btn-primary btn-sm" (click)="open()">
      <i class="bi bi-person-plus-fill me-1"></i> Novo Profissional
    </button>
  </div>
  <hr/>

  <!-- Loading -->
  <div class="text-center py-5" *ngIf="loading && professionals.length === 0">
    <div class="spinner-border text-primary"></div>
  </div>

  <!-- Empty -->
  <div class="empty-state" *ngIf="!loading && professionals.length === 0">
    <div class="empty-icon"><i class="bi bi-people" style="font-size: 4rem;"></i></div>
    <h4>Nenhum profissional cadastrado</h4>
    <p class="text-muted">Comece cadastrando seu primeiro profissional com 30 dias grátis!</p>
    <button class="btn btn-primary btn-lg" (click)="open()">
      <i class="bi bi-plus-lg me-2"></i>Cadastrar Primeiro Profissional
    </button>
  </div>

  <!-- Cards Grid -->
  <div class="row g-4" *ngIf="professionals.length > 0">
    <div class="col-sm-12 col-md-6 col-xl-4" *ngFor="let p of professionals">
      <div class="pro-card" [class.inactive]="!p.isActive">

        <!-- Topo: status + assinatura -->
        <div class="pro-topbar">
          <span class="status-dot" [class.active]="p.isActive">
            {{ p.isActive ? '● Ativo' : '○ Inativo' }}
          </span>
          <span [class]="subClass(p.subscription?.status)" style="font-size:.75rem">
            {{ subLabel(p.subscription?.status) }}
          </span>
        </div>

        <!-- Header com avatar -->
        <div class="pro-header">
          <div class="pro-avatar">{{ p.name.substring(0,2).toUpperCase() }}</div>
          <div class="pro-meta">
            <h5 class="mb-1">{{ p.name }}</h5>
            <span class="specialty">{{ p.specialty || 'Especialidade não informada' }}</span>
            <div class="register-id" *ngIf="p.professionalId">
              <i class="bi bi-card-text"></i> {{ p.professionalId }}
            </div>
          </div>
        </div>

        <!-- Trial warning -->
        <div class="trial-bar" *ngIf="p.subscription?.status === 1">
          <i class="bi bi-clock-history"></i>
          <span>Trial: <strong>{{ daysRemaining(p.subscription?.trialEndDate) }} dias</strong> restantes</span>
        </div>
        <div class="pastdue-bar" *ngIf="p.subscription?.status === 3">
          <i class="bi bi-exclamation-triangle-fill"></i>
          <span>Pagamento atrasado — configure o pagamento!</span>
        </div>
        <div class="suspended-bar" *ngIf="p.subscription?.status === 4">
          <i class="bi bi-lock-fill"></i>
          <span>Acesso suspenso por falta de pagamento</span>
        </div>

        <!-- Forma de pagamento -->
        <div class="payment-info" style="display:none">
          <div *ngIf="p.billingConfig?.isConfigured; else noBilling">
            <i class="bi" [class.bi-qr-code]="p.billingConfig.preferredPaymentMethod === 1"
               [class.bi-credit-card]="p.billingConfig.preferredPaymentMethod === 2"></i>
            <span *ngIf="p.billingConfig.preferredPaymentMethod === 1">
              PIX · {{ p.billingConfig.pixKey }}
            </span>
            <span *ngIf="p.billingConfig.preferredPaymentMethod === 2">
              {{ p.billingConfig.cardBrand }} **** {{ p.billingConfig.cardLastFourDigits }}
              ({{ p.billingConfig.cardExpiryMonth }}/{{ p.billingConfig.cardExpiryYear }})
            </span>
          </div>
          <ng-template #noBilling>
            <span class="text-warning">
              <i class="bi bi-exclamation-circle"></i> Pagamento não configurado
            </span>
          </ng-template>
        </div>

        <!-- Contatos -->
        <div class="contact-info">
          <div *ngIf="p.email"><i class="bi bi-envelope"></i> {{ p.email }}</div>
          <div *ngIf="p.phone"><i class="bi bi-telephone"></i> {{ p.phone }}</div>
        </div>

        <!-- Ações -->
        <div class="pro-actions">
          <button class="btn btn-sm btn-outline-primary" (click)="open(p)">
            <i class="bi bi-pencil"></i> Editar
          </button>
          <button style="display:none" class="btn btn-sm btn-outline-success" (click)="open(p); openTab('pagamento')">
            <i class="bi bi-credit-card"></i> Pagamento
          </button>
          <button class="btn btn-sm btn-outline-info" (click)="open(p); openTab('assinatura')">
            <i class="bi bi-check-circle-fill"></i>
          </button>
           <button class="btn btn-sm btn-outline-info" (click)="open(p); openTab('horarios')">
            <i class="bi bi-calendar-check"></i>
          </button>
          <button class="btn btn-sm"
                  [class.btn-outline-danger]="p.isActive"
                  [class.btn-outline-success]="!p.isActive"
                  (click)="toggleStatus(p)">
            <i class="bi" [class.bi-toggle-on]="p.isActive" [class.bi-toggle-off]="!p.isActive"></i>
          </button>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- ======================================================
     MODAL PRINCIPAL
     ====================================================== -->
<div class="modal-overlay" *ngIf="showModal" (click)="close()"></div>
<div class="modal-wrapper" *ngIf="showModal">
  <div class="modal-panel">

    <!-- Abas do modal -->
    <div class="modal-nav">
      <button class="nav-tab" [class.active]="modalTab === 'dados'" (click)="openTab('dados')">
        <i class="bi bi-person-badge"></i> Dados
      </button>
      <button style="display:none" class="nav-tab" [class.active]="modalTab === 'pagamento'" (click)="openTab('pagamento')">
        <i class="bi bi-credit-card"></i> Pagamento
        <span class="dot-alert" *ngIf="!billing.isConfigured"></span>
      </button>
      <button class="nav-tab" [class.active]="modalTab === 'assinatura'"
              *ngIf="isEditing" (click)="openTab('assinatura')">
        <i class="bi bi-calendar-check"></i> Assinatura
      </button>
      <button class="nav-tab" [class.active]="modalTab === 'horarios'"
              *ngIf="isEditing" (click)="openTab('horarios')">
        <i class="bi bi-clock"></i> Horários
      </button>
      <button style="display:none" class="nav-tab" [class.active]="modalTab === 'usuarios'"
              *ngIf="isEditing" (click)="openTab('usuarios')">
        <i class="bi bi-people"></i> Usuários
      </button>
      <button class="nav-tab" [class.active]="modalTab === 'indicacoes'"
              *ngIf="isEditing" (click)="openTab('indicacoes')">
        <i class="bi bi-gift"></i> Indicações
      </button>
      <button class="btn-close-modal" (click)="close()">✕</button>
    </div>

    <div class="modal-scroll">

      <!-- =============== ABA: DADOS =============== -->
      <div *ngIf="modalTab === 'dados'" class="tab-content-area">
        <div class="row g-3">
          <div class="col-12">
            <label class="form-label">Nome Completo *</label>
            <input type="text" class="form-control form-control-lg" [(ngModel)]="form.name"
                   placeholder="Ex: Dr. João Silva">
          </div>
          <div class="col-md-6">
            <label class="form-label">Especialidade</label>
            <select class="form-select" [(ngModel)]="form.specialty">
              <option value="">Selecione...</option>
              <option>Cardiologista</option><option>Clínico Geral</option>
              <option>Dermatologista</option><option>Dentista</option>
              <option>Fisioterapeuta</option><option>Ginecologista</option>
              <option>Nutricionista</option><option>Ortopedista</option>
              <option>Pediatra</option><option>Personal Trainer</option>
              <option>Psicólogo</option><option>Psiquiatra</option>
              <option>Terapeuta</option><option>Outro</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">Nº Registro (CRM / CRP / CREFITO...)</label>
            <input type="text" class="form-control" [(ngModel)]="form.professionalId"
                   placeholder="Ex: CRM 12345-SP">
          </div>
          <div class="col-md-6">
            <label class="form-label">E-mail</label>
            <input type="email" class="form-control" [(ngModel)]="form.email" placeholder="profissional@email.com">
          </div>
          <div class="col-md-6">
            <label class="form-label">Confirmar E-mail</label>
            <input type="email" class="form-control"
                   [class.is-invalid]="form.emailConfirm && form.email !== form.emailConfirm"
                   [class.is-valid]="form.email && form.email === form.emailConfirm"
                   [(ngModel)]="form.emailConfirm" placeholder="Repita o e-mail">
            <div class="invalid-feedback" *ngIf="form.emailConfirm && form.email !== form.emailConfirm">
              Os e-mails não conferem.
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label">Telefone</label>
            <input type="tel" class="form-control" [(ngModel)]="form.phone"
                   (input)="onPhoneInput($event)"
                   placeholder="(11) 98765-4321" maxlength="15">
          </div>

          <!-- Endereço -->
          <div class="col-12 mt-3">
            <h6 class="text-muted mb-2"><i class="bi bi-geo-alt me-1"></i>Endereço</h6>
          </div>
          <div class="col-md-8">
            <label class="form-label">Endereço</label>
            <input type="text" class="form-control" [(ngModel)]="form.address" placeholder="Rua, Avenida, etc">
          </div>
          <div class="col-md-4">
            <label class="form-label">Número</label>
            <input type="text" class="form-control" [(ngModel)]="form.number" placeholder="123">
          </div>
          <div class="col-md-6">
            <label class="form-label">Bairro</label>
            <input type="text" class="form-control" [(ngModel)]="form.neighborhood" placeholder="Centro">
          </div>
          <div class="col-md-6">
            <label class="form-label">Complemento</label>
            <input type="text" class="form-control" [(ngModel)]="form.complement" placeholder="Apto, Sala, etc">
          </div>
          <div class="col-md-5">
            <label class="form-label">Cidade</label>
            <input type="text" class="form-control" [(ngModel)]="form.city" placeholder="São Paulo">
          </div>
          <div class="col-md-3">
            <label class="form-label">Estado (UF)</label>
            <input type="text" class="form-control" [(ngModel)]="form.state" placeholder="SP" maxlength="2">
          </div>
          <div class="col-md-4">
            <label class="form-label">CEP</label>
            <input type="text" class="form-control" [(ngModel)]="form.zipCode" placeholder="00000-000">
          </div>

          <div class="col-12">
            <label class="form-label">Observações</label>
            <textarea class="form-control" rows="3" [(ngModel)]="form.notes"
                      placeholder="Informações adicionais..."></textarea>
          </div>
        </div>

        <!-- Banner trial (apenas criação) -->
        <div class="trial-banner" *ngIf="!isEditing">
          <div class="trial-banner-icon">🎉</div>
          <div>
            <strong>30 dias grátis para testar!</strong>
            <p class="mb-0 mt-1">Após o período de trial, será cobrado <strong>R$ 39,90/mês</strong> por
              profissional. Configure a forma de pagamento na aba <strong>Pagamento</strong>.</p>
          </div>
        </div>
      </div>

      <!-- =============== ABA: PAGAMENTO =============== -->
      <div *ngIf="modalTab === 'pagamento'" class="tab-content-area">
        <h6 class="section-title">Como deseja pagar <span class="price-highlight">R$ 39,90/mês</span>?</h6>

        <!-- Seletor PIX vs Cartão -->
        <div class="method-grid mb-4">
          <div class="method-card" [class.selected]="billing.preferredPaymentMethod === 1"
               (click)="billing.preferredPaymentMethod = 1">
            <div class="method-icon">📱</div>
            <div class="method-info">
              <strong>PIX</strong>
              <small>Você recebe um boleto/QR Code mensalmente</small>
            </div>
            <i class="bi bi-check-circle-fill check"></i>
          </div>

          <!-- ----
          <div class="method-card" [class.selected]="billing.preferredPaymentMethod === 2"
               (click)="billing.preferredPaymentMethod = 2">
            <div class="method-icon">💳</div>
            <div class="method-info">
              <strong>Cartão de Crédito</strong>
              <small>Cobrança automática todo mês</small>
            </div>
            <i class="bi bi-check-circle-fill check"></i>
          </div> 
          ---- -->
        </div>

        <!-- ---- Formulário PIX ---- -->
        <div *ngIf="billing.preferredPaymentMethod === 1" class="form-section">
          <h6 class="form-section-title">
            <i class="bi bi-qr-code me-2"></i>Dados da Chave PIX
          </h6>
          <div class="row g-3">
            <div class="col-md-5">
              <label class="form-label">Tipo de Chave</label>
              <select class="form-select" [(ngModel)]="billing.pixKeyType">
                <option [ngValue]="3">E-mail</option>
                <option [ngValue]="1">CPF</option>
                <option [ngValue]="2">CNPJ</option>
                <option [ngValue]="4">Telefone</option>
                <option [ngValue]="5">Chave Aleatória</option>
              </select>
            </div>
            <div class="col-md-7">
              <label class="form-label">Chave PIX</label>
              <input type="text" class="form-control" [(ngModel)]="billing.pixKey"
                     [placeholder]="pixPlaceholder()">
            </div>
            <div class="col-12">
              <label class="form-label">Nome do Titular da Conta</label>
              <input type="text" class="form-control" [(ngModel)]="billing.pixHolderName"
                     placeholder="Como aparece na conta bancária">
            </div>
          </div>
          <div class="info-box info-blue mt-3">
            <i class="bi bi-info-circle-fill"></i>
            Próximo ao vencimento, você receberá um e-mail com o QR Code para pagamento.
            Após a confirmação, a assinatura é renovada automaticamente.
          </div>
        </div>

        <!-- ---- Formulário Cartão ---- -->
        <div *ngIf="billing.preferredPaymentMethod === 2" class="form-section">
          <h6 class="form-section-title">
            <i class="bi bi-credit-card me-2"></i>Dados do Cartão
          </h6>
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label">Nome no Cartão</label>
              <input type="text" class="form-control" [(ngModel)]="billing.cardHolderName"
                     placeholder="NOME COMO NO CARTÃO">
            </div>
            <div class="col-12">
              <label class="form-label">Número do Cartão</label>
              <div class="card-input-wrapper">
                <input type="text" class="form-control card-input" [(ngModel)]="cardNumberDisplay"
                       placeholder="0000 0000 0000 0000" maxlength="19"
                       (input)="formatCard($event)">
                <span class="card-brand-badge" *ngIf="billing.cardBrand">{{ billing.cardBrand }}</span>
              </div>
            </div>
            <div class="col-6">
              <label class="form-label">Validade</label>
              <input type="text" class="form-control" [(ngModel)]="cardExpiry"
                     placeholder="MM/AA" maxlength="5" (input)="formatExpiry($event)">
            </div>
            <div class="col-6">
              <label class="form-label">CVV</label>
              <input type="password" class="form-control" [(ngModel)]="cardCvv"
                     placeholder="•••" maxlength="4">
            </div>
          </div>
          <div class="info-box info-green mt-3">
            <i class="bi bi-shield-lock-fill"></i>
            Dados protegidos por criptografia SSL 256-bit. O número do cartão nunca é armazenado
            em nossos servidores — apenas um token seguro do gateway de pagamento.
          </div>
        </div>
      </div>

      <!-- =============== ABA: ASSINATURA =============== -->
      <div *ngIf="modalTab === 'assinatura'" class="tab-content-area">

        <!-- Loading assinatura -->
        <div class="text-center py-4" *ngIf="!subscription">
          <div class="spinner-border text-primary spinner-border-sm"></div>
          <p class="mt-2 text-muted">Carregando assinatura...</p>
        </div>

        <div *ngIf="subscription">
          <!-- Resumo assinatura -->
          <div class="sub-card">
            <div class="sub-card-left">
              <div class="sub-label">Status da Assinatura</div>
              <span [class]="subClass(subscription.status)" style="font-size:.9rem; padding:6px 12px;">
                {{ subLabel(subscription.status) }}
              </span>
              <div class="sub-dates mt-3">
                <div class="sub-date" *ngIf="subscription.status === 1">
                  <i class="bi bi-calendar-event text-info"></i>
                  <div>
                    <small>Trial termina em</small>
                    <strong>{{ fmtDate(subscription.trialEndDate) }}</strong>
                    <small class="remaining">({{ daysRemaining(subscription.trialEndDate) }} dias)</small>
                  </div>
                </div>
                <div class="sub-date" *ngIf="subscription.nextBillingDate">
                  <i class="bi bi-calendar-check"></i>
                  <div>
                    <small>Próxima cobrança</small>
                    <strong>{{ fmtDate(subscription.nextBillingDate) }}</strong>
                  </div>
                </div>
                <div class="sub-date">
                  <i class="bi bi-calendar-plus"></i>
                  <div>
                    <small>Início da assinatura</small>
                    <strong>{{ fmtDate(subscription.startDate) }}</strong>
                  </div>
                </div>
              </div>
            </div>
            <div class="sub-card-right">
              <div class="sub-price">R$ 39,90</div>
              <div class="sub-period">/ mês</div>
              <div class="sub-plan">Plano Mensal</div>
            </div>
          </div>

          <!-- Histórico de pagamentos -->
          <h6 class="section-title mt-4">Histórico de Pagamentos</h6>
          <div *ngIf="subscription.payments?.length === 0" class="text-center text-muted py-3">
            <i class="bi bi-receipt"></i> Nenhum pagamento registrado
          </div>
          <div class="payment-row" *ngFor="let pay of subscription.payments">
            <div class="pay-left">
              <i class="bi" [class]="payMethodIcon(pay.paymentMethod)"></i>
              <div>
                <strong>{{ fmtCurrency(pay.amount) }}</strong>
                <small class="text-muted">Venc: {{ fmtDate(pay.dueDate) }}</small>
              </div>
            </div>
            <div class="pay-right">
              <span class="badge"
                    [class.bg-success]="pay.status === 2"
                    [class.bg-warning]="pay.status === 1"
                    [class.bg-danger]="pay.status === 3"
                    [class.bg-secondary]="pay.status > 3">
                {{ payStatusLabel(pay.status) }}
              </span>
              <small *ngIf="pay.paidAt" class="text-success ms-2">
                {{ fmtDate(pay.paidAt) }}
              </small>
            </div>
          </div>
        </div>

      </div>

      <!-- =============== ABA: HORÁRIOS =============== -->
      <div *ngIf="modalTab === 'horarios'" class="tab-content-area">
        <h6 class="section-title">Faixas de Atendimento</h6>
        <p class="text-muted small mb-3">Configure manhã e tarde por dia. Slot = duração de cada consulta. Intervalo = descanso entre slots.</p>

        <div *ngFor="let day of workingHours" class="wh-day-block">
          <!-- Cabeçalho do dia -->
          <div class="wh-day-header">
            <span class="wh-day-name">{{ dayNames[day.dayOfWeek] }}</span>
            <div class="wh-day-config" *ngIf="day.morning.isActive || day.afternoon.isActive">
              <div class="wh-cfg-item">
                <label class="wh-cfg-label">Slot</label>
                <select class="form-select form-select-sm wh-select"
                        [(ngModel)]="day.slotDurationMinutes">
                  <option [ngValue]="15">15 min</option>
                  <option [ngValue]="30">30 min</option>
                  <option [ngValue]="45">45 min</option>
                  <option [ngValue]="50">50 min</option>
                  <option [ngValue]="60">60 min</option>
                </select>
              </div>
              <div class="wh-cfg-item">
                <label class="wh-cfg-label">Intervalo</label>
                <select class="form-select form-select-sm wh-select"
                        [(ngModel)]="day.intervalMinutes">
                  <option [ngValue]="0">0 min</option>
                  <option [ngValue]="1">1 min</option>
                  <option [ngValue]="5">5 min</option>
                  <option [ngValue]="10">10 min</option>
                  <option [ngValue]="15">15 min</option>
                  <option [ngValue]="30">30 min</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Bloco Manhã (00:00–13:00) -->
          <div class="wh-block" [class.wh-block-active]="day.morning.isActive">
            <label class="wh-check-label">
              <input type="checkbox" class="form-check-input me-1"
                     [(ngModel)]="day.morning.isActive">
              <span class="wh-period">Manhã</span>
            </label>
            <div class="wh-times" *ngIf="day.morning.isActive">
              <div class="wh-time-sel">
                <select class="form-select form-select-sm wh-th"
                        [ngModel]="getHour(day.morning.startTime)"
                        (ngModelChange)="setHour(day.morning, 'startTime', $event)">
                  <option *ngFor="let h of morningHours" [ngValue]="h">{{ padTime(h) }}</option>
                </select>
                <span class="wh-tc">:</span>
                <select class="form-select form-select-sm wh-tm"
                        [ngModel]="getMin(day.morning.startTime)"
                        (ngModelChange)="setMin(day.morning, 'startTime', $event)">
                  <option *ngFor="let m of timeMinutes" [ngValue]="m">{{ padTime(m) }}</option>
                </select>
              </div>
              <span class="wh-sep">às</span>
              <div class="wh-time-sel">
                <select class="form-select form-select-sm wh-th"
                        [ngModel]="getHour(day.morning.endTime)"
                        (ngModelChange)="setHour(day.morning, 'endTime', $event)">
                  <option *ngFor="let h of morningHours" [ngValue]="h">{{ padTime(h) }}</option>
                </select>
                <span class="wh-tc">:</span>
                <select class="form-select form-select-sm wh-tm"
                        [ngModel]="getMin(day.morning.endTime)"
                        (ngModelChange)="setMin(day.morning, 'endTime', $event)">
                  <option *ngFor="let m of timeMinutes" [ngValue]="m">{{ padTime(m) }}</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Bloco Tarde (12:00–23:59) -->
          <div class="wh-block" [class.wh-block-active]="day.afternoon.isActive">
            <label class="wh-check-label">
              <input type="checkbox" class="form-check-input me-1"
                     [(ngModel)]="day.afternoon.isActive">
              <span class="wh-period">Tarde</span>
            </label>
            <div class="wh-times" *ngIf="day.afternoon.isActive">
              <div class="wh-time-sel">
                <select class="form-select form-select-sm wh-th"
                        [ngModel]="getHour(day.afternoon.startTime)"
                        (ngModelChange)="setHour(day.afternoon, 'startTime', $event)">
                  <option *ngFor="let h of afternoonHours" [ngValue]="h">{{ padTime(h) }}</option>
                </select>
                <span class="wh-tc">:</span>
                <select class="form-select form-select-sm wh-tm"
                        [ngModel]="getMin(day.afternoon.startTime)"
                        (ngModelChange)="setMin(day.afternoon, 'startTime', $event)">
                  <option *ngFor="let m of timeMinutes" [ngValue]="m">{{ padTime(m) }}</option>
                </select>
              </div>
              <span class="wh-sep">às</span>
              <div class="wh-time-sel">
                <select class="form-select form-select-sm wh-th"
                        [ngModel]="getHour(day.afternoon.endTime)"
                        (ngModelChange)="setHour(day.afternoon, 'endTime', $event)">
                  <option *ngFor="let h of afternoonHours" [ngValue]="h">{{ padTime(h) }}</option>
                </select>
                <span class="wh-tc">:</span>
                <select class="form-select form-select-sm wh-tm"
                        [ngModel]="getMin(day.afternoon.endTime)"
                        (ngModelChange)="setMin(day.afternoon, 'endTime', $event)">
                  <option *ngFor="let m of timeMinutes" [ngValue]="m">{{ padTime(m) }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button class="btn btn-primary" (click)="saveWorkingHours()" [disabled]="savingHours">
            <span *ngIf="savingHours" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!savingHours" class="bi bi-check-lg me-1"></i>
            Salvar Horários
          </button>
        </div>
      </div>

      <!-- =============== ABA: USUÁRIOS =============== -->
      <div *ngIf="modalTab === 'usuarios'" class="tab-content-area">
        <h6 class="section-title">Usuários Vinculados</h6>
        <p class="text-muted small mb-3">Gerencie quais usuários têm acesso a este profissional e qual é o papel de cada um.</p>

        <!-- Lista de usuários vinculados -->
        <div class="user-row" *ngFor="let u of users">
          <div class="user-avatar-sm">{{ (u.name || '?').substring(0,2).toUpperCase() }}</div>
          <div class="user-info">
            <strong>{{ u.name || '(sem nome)' }}</strong>
            <small class="text-muted d-block">{{ u.email }}</small>
          </div>
          <div class="user-badges d-flex align-items-center gap-2">
            <span class="badge bg-primary" *ngIf="u.isOwner">Owner</span>
            <span class="badge bg-info text-dark" *ngIf="!u.isOwner && u.role === 'Collaborator'">Colaborador</span>
            <span class="badge bg-secondary" *ngIf="!u.isOwner && u.role !== 'Collaborator'">{{ u.role }}</span>
            <button class="btn btn-sm btn-outline-danger ms-1"
                    *ngIf="!u.isOwner"
                    [disabled]="userRemovingId === u.userId"
                    (click)="removeUser(u.userId)">
              <span *ngIf="userRemovingId === u.userId" class="spinner-border spinner-border-sm"></span>
              <i *ngIf="userRemovingId !== u.userId" class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>

        <div class="text-center text-muted py-3" *ngIf="users.length === 0">
          <i class="bi bi-people fs-3 d-block mb-1"></i>
          Nenhum usuário vinculado
        </div>

        <!-- Busca e vínculo de novo usuário -->
        <hr class="my-3">
        <h6 class="section-title">Adicionar Usuário</h6>

        <div class="row g-2 align-items-end">
          <div class="col">
            <label class="form-label">E-mail do Usuário</label>
            <input type="email" class="form-control" [(ngModel)]="userSearchEmail"
                   placeholder="usuario@email.com"
                   (keydown.enter)="searchUser()">
          </div>
          <div class="col-auto">
            <button class="btn btn-outline-primary" (click)="searchUser()" [disabled]="userSearching">
              <span *ngIf="userSearching" class="spinner-border spinner-border-sm"></span>
              <i *ngIf="!userSearching" class="bi bi-search"></i>
              Buscar
            </button>
          </div>
        </div>

        <!-- Erro de busca -->
        <div class="alert alert-warning mt-2 py-2" *ngIf="userSearchError">
          <i class="bi bi-exclamation-circle me-1"></i>{{ userSearchError }}
        </div>

        <!-- Resultado encontrado -->
        <div class="user-found-card mt-3" *ngIf="userSearchResult">
          <div class="user-found-info">
            <div class="user-avatar-sm">{{ userSearchResult.name.substring(0,2).toUpperCase() }}</div>
            <div>
              <strong>{{ userSearchResult.name }}</strong>
              <small class="text-muted d-block">{{ userSearchResult.email }}</small>
            </div>
          </div>
          <div class="d-flex align-items-center gap-2 mt-2">
            <label class="form-label mb-0 me-1">Papel:</label>
            <select class="form-select form-select-sm" style="width:auto" [(ngModel)]="userLinkRole">
              <option value="Collaborator">Colaborador</option>
              <option value="Owner">Owner</option>
            </select>
            <button class="btn btn-sm btn-primary" (click)="linkUser()" [disabled]="userLinking">
              <span *ngIf="userLinking" class="spinner-border spinner-border-sm me-1"></span>
              <i *ngIf="!userLinking" class="bi bi-link-45deg me-1"></i>
              Vincular
            </button>
          </div>
        </div>

        <!-- Enviar Convite por Email -->
        <hr class="my-3">
        <h6 class="section-title">Enviar Convite por Email</h6>
        <p class="text-muted small mb-3">Envie um convite para um email que ainda não possui conta. O link expira em 7 dias.</p>

        <div class="row g-2 align-items-end">
          <div class="col-md-6">
            <label class="form-label">E-mail do Convidado</label>
            <input type="email" class="form-control" [(ngModel)]="inviteEmail"
                   placeholder="colaborador@email.com">
          </div>
          <div class="col-md-3">
            <label class="form-label">Papel</label>
            <select class="form-select" [(ngModel)]="inviteRole">
              <option value="Collaborator">Colaborador</option>
              <option value="Owner">Owner</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label">Permissões</label>
            <select class="form-select" [(ngModel)]="invitePermissions">
              <option value="read">Leitura</option>
              <option value="all">Todas</option>
            </select>
          </div>
          <div class="col-12">
            <button class="btn btn-success" (click)="sendInvite()" [disabled]="sendingInvite">
              <span *ngIf="sendingInvite" class="spinner-border spinner-border-sm me-1"></span>
              <i *ngIf="!sendingInvite" class="bi bi-envelope me-1"></i>
              Enviar Convite
            </button>
          </div>
        </div>

        <!-- Lista de Convites Pendentes -->
        <div class="mt-3" *ngIf="invites && invites.length > 0">
          <h6 class="section-title mt-3">Convites Enviados</h6>
          <div class="invite-row" *ngFor="let inv of invites">
            <div class="invite-info">
              <strong>{{ inv.email }}</strong>
              <small class="text-muted d-block">
                {{ inv.role }} · {{ inv.permissions === 'all' ? 'Todas permissões' : 'Somente leitura' }}
              </small>
              <small class="text-muted">
                Expira em: {{ fmtDate(inv.expiresAt) }}
              </small>
            </div>
            <div class="invite-status">
              <span class="badge bg-success" *ngIf="inv.isUsed">✓ Usado</span>
              <span class="badge bg-warning text-dark" *ngIf="!inv.isUsed && !isExpired(inv.expiresAt)">⏳ Pendente</span>
              <span class="badge bg-secondary" *ngIf="!inv.isUsed && isExpired(inv.expiresAt)">✕ Expirado</span>
            </div>
          </div>
        </div>
      </div>

      <!-- =============== ABA: INDICAÇÕES =============== -->
      <div *ngIf="modalTab === 'indicacoes'" class="tab-content-area">

        <!-- Formulário de Nova Indicação -->
        <div class="referral-form-card">
          <h4>📧 Enviar Nova Indicação</h4>
          <p class="help-text">Digite o email do profissional que você deseja indicar. Ele receberá um link válido por 72 horas.</p>

          <div class="row g-3">
            <div class="col-md-8">
              <label class="form-label">Email do Profissional</label>
              <input
                type="email"
                class="form-control"
                [(ngModel)]="referralEmail"
                placeholder="exemplo@email.com"
                [disabled]="sendingReferral"
                (keyup.enter)="sendReferral()">
            </div>
            <div class="col-md-4 d-flex align-items-end">
              <button
                type="button"
                class="btn btn-light w-100"
                (click)="sendReferral()"
                [disabled]="sendingReferral || !referralEmail.trim()">
                <span *ngIf="sendingReferral">Enviando...</span>
                <span *ngIf="!sendingReferral">✉️ Enviar Indicação</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters-section">
          <div class="row g-3">
            <div class="col-md-3">
              <label class="form-label">Filtrar por Status</label>
              <select
                class="form-control"
                [(ngModel)]="referralFilter.status"
                (change)="loadReferrals()">
                <option [ngValue]="null">Todos</option>
                <option [ngValue]="1">Pendente</option>
                <option [ngValue]="2">Aceito</option>
                <option [ngValue]="3">Ativo</option>
                <option [ngValue]="4">Cancelado</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Loading -->
        <div *ngIf="loadingReferrals" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Carregando...</span>
          </div>
          <p class="mt-2 text-muted">Carregando indicações...</p>
        </div>

        <!-- Listagem -->
        <div *ngIf="!loadingReferrals">

          <!-- Empty State -->
          <div *ngIf="referrals.length === 0" class="empty-state">
            <i class="bi bi-inbox" style="font-size: 48px; opacity: 0.3;"></i>
            <p class="mt-3">📭 Nenhuma indicação encontrada</p>
            <small class="text-muted">Envie convites para profissionais que você conhece!</small>
          </div>

          <!-- Cards de Indicações -->
          <div class="referrals-list">
            <div *ngFor="let ref of referrals" class="referral-card">

              <!-- Header -->
              <div class="referral-header">
                <div class="referral-email">
                  <strong>{{ ref.referredEmail }}</strong>
                  <span
                    class="badge ms-2"
                    [class.bg-warning]="ref.status === 1"
                    [class.bg-info]="ref.status === 2"
                    [class.bg-success]="ref.status === 3"
                    [class.bg-secondary]="ref.status === 4">
                    {{ ref.statusLabel }}
                  </span>
                </div>

                <!-- Botão Delete (só para Pendente e Cancelado) -->
                <button
                  *ngIf="ref.canDelete"
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  (click)="deleteReferral(ref)"
                  [disabled]="deletingReferralId === ref.id"
                  title="Excluir">
                  <i class="bi bi-trash" *ngIf="deletingReferralId !== ref.id"></i>
                  <span class="spinner-border spinner-border-sm" *ngIf="deletingReferralId === ref.id"></span>
                </button>
              </div>

              <!-- Detalhes -->
              <div class="referral-details">
                <div class="detail-row">
                  <span class="label">Enviado:</span>
                  <span>{{ ref.sentAt | date:'dd/MM/yyyy HH:mm' }}</span>
                </div>

                <div class="detail-row" *ngIf="ref.status === 1">
                  <span class="label">Expira:</span>
                  <span>{{ ref.expiresAt | date:'dd/MM/yyyy HH:mm' }}</span>
                </div>

                <div class="detail-row" *ngIf="ref.acceptedAt">
                  <span class="label">Aceito:</span>
                  <span>{{ ref.acceptedAt | date:'dd/MM/yyyy HH:mm' }}</span>
                </div>

                <div class="detail-row" *ngIf="ref.activatedAt">
                  <span class="label">Ativado:</span>
                  <span>{{ ref.activatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
                </div>

                <div class="detail-row" *ngIf="ref.cancelledAt">
                  <span class="label">Cancelado:</span>
                  <span>{{ ref.cancelledAt | date:'dd/MM/yyyy HH:mm' }}</span>
                </div>

                <div class="detail-row" *ngIf="ref.referredProfessionalName">
                  <span class="label">Profissional:</span>
                  <span><strong>{{ ref.referredProfessionalName }}</strong></span>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>

    </div><!-- /modal-scroll -->

    <!-- Footer -->
    <div class="modal-footer-bar">
      <button class="btn btn-secondary" (click)="close()">Cancelar</button>
      <button class="btn btn-primary" (click)="save()" [disabled]="loading || !emailsMatchProf"
              *ngIf="modalTab !== 'horarios' && modalTab !== 'usuarios' && modalTab !== 'indicacoes'">
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
        {{ isEditing ? 'Salvar Alterações' : 'Salvar' }}
      </button>
    </div>

  </div>
</div>
